import { render, staticRenderFns } from "./MiddleBox.vue?vue&type=template&id=2d04dfc4&scoped=true&"
import script from "./MiddleBox.vue?vue&type=script&lang=js&"
export * from "./MiddleBox.vue?vue&type=script&lang=js&"
import style0 from "./MiddleBox.vue?vue&type=style&index=0&id=2d04dfc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04dfc4",
  null
  
)

export default component.exports